import Image from 'next/image';

import styled, { keyframes } from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';

export const SplashLoaderContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.neutral[950]};
  display: flex;
  flex-direction: column;
  gap: ${SPACING._32};
  justify-content: center;
  align-items: center;
`;

const blinkAnimation = keyframes`
  0%, 100% {
    filter: brightness(1.0);
  }
  50% {
    filter: brightness(1.5);
  }
`;

export const BlinkingImage = styled(Image)`
  transition: 100ms;
  animation: ${blinkAnimation} 1s infinite;
`;
